import { Fields } from '~/components/partials/GuestPatientForm/types';
import { CheckinEntryItemFragment } from '~/graphql/generated/graphql';

export const useDefaultValues = (checkinEntry: CheckinEntryItemFragment) => {
  const defaultValues: Fields = {
    familyName: checkinEntry.familyName,
    givenName: checkinEntry.givenName,
    phoneticFamilyName: checkinEntry.phoneticFamilyName,
    phoneticGivenName: checkinEntry.phoneticGivenName,
    birthDate: '',
    sex: 'male',
    mobilePhone: checkinEntry.phoneNumber,
  };

  return defaultValues;
};
